<template>
  <div class="slider">
    <RangeSlider
      :min="this.min"
      :max="this.max"
      :step="question.step_value"
      :value="val"
      :edit_mode="false"
      @change="handleChange"
      class="mt-3"
    />
  </div>
</template>
<script lang="ts">
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'
import { useValidationStore } from '@/survey/stores/ValidationStore.ts'
import RangeSlider from '@survey/components/RangeSlider.vue'

export default {
  components: { RangeSlider },
  props: {
    question: { type: Object, required: true },
  },
  data() {
    return {
      val: undefined,
    }
  },
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses', 'findResponseByQuestionId']),
    ...mapState(useValidationStore, ['addError', 'registerValidationFunction', 'validate']),
    min() {
      return this.question.min_value || 0
    },
    max() {
      return this.question.max_value || 10
    },
    answer() {
      return this.question.answers[0]
    },
    response() {
      return this.findResponseByQuestionId(this.question.id)
    },
  },
  mounted() {
    this.registerValidationFunction(this.question.id, this._validate)
    this.val = this.response?.value_answer
  },
  methods: {
    handleChange(newValue) {
      this.val = Number(newValue)
      const responseData = {
        question_id: this.question.id,
        response_id: this.response?.id,
        answer_id: this.answer.id,
        value_answer: newValue,
      }
      this.validate(this.question.id)
      this.$emit('change', responseData)
    },
    _validate() {
      if (this.question.required && !this.val) {
        this.addError(this.question.id, 'Please choose a value')
      }
    },
  },
}
</script>
